import '../assets/NcInputConfirmCancel-DBjIHKvN.css';
import { N as NcButton } from "./NcButton-Bhuckhtj.mjs";
import { r as register, m as t13, a as t } from "./_l10n-6dsjYig_.mjs";
import { A as ArrowRight } from "./ArrowRight-Cg6xGDcS.mjs";
import { C as Close } from "./Close-pmiXntgw.mjs";
import { resolveComponent, openBlock, createElementBlock, createElementVNode, withModifiers, withKeys, withDirectives, vModelText, createVNode, withCtx } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register(t13);
const _sfc_main = {
  name: "NcInputConfirmCancel",
  components: {
    NcButton,
    ArrowRight,
    Close
  },
  props: {
    /**
     * If this element is used on a primary element set to true for primary styling.
     */
    primary: {
      default: false,
      type: Boolean
    },
    placeholder: {
      default: "",
      type: String
    },
    modelValue: {
      default: "",
      type: String
    }
  },
  emits: [
    "cancel",
    "confirm",
    "update:modelValue"
  ],
  data() {
    return {
      labelConfirm: t("Confirm changes"),
      labelCancel: t("Cancel changes")
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      }
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
    focusInput() {
      this.$refs.input.focus();
    }
  }
};
const _hoisted_1 = { class: "app-navigation-input-confirm" };
const _hoisted_2 = ["placeholder"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowRight = resolveComponent("ArrowRight");
  const _component_NcButton = resolveComponent("NcButton");
  const _component_Close = resolveComponent("Close");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = withModifiers((...args) => $options.confirm && $options.confirm(...args), ["prevent"])),
      onKeydown: _cache[2] || (_cache[2] = withKeys(withModifiers((...args) => $options.cancel && $options.cancel(...args), ["exact", "stop", "prevent"]), ["esc"])),
      onClick: _cache[3] || (_cache[3] = withModifiers(() => {
      }, ["stop", "prevent"]))
    }, [
      withDirectives(createElementVNode("input", {
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $options.valueModel = $event),
        type: "text",
        class: "app-navigation-input-confirm__input",
        placeholder: $props.placeholder
      }, null, 8, _hoisted_2), [
        [vModelText, $options.valueModel]
      ]),
      createVNode(_component_NcButton, {
        "native-type": "submit",
        type: "primary",
        "aria-label": $data.labelConfirm,
        onClick: withModifiers($options.confirm, ["stop", "prevent"])
      }, {
        icon: withCtx(() => [
          createVNode(_component_ArrowRight, { size: 20 })
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"]),
      createVNode(_component_NcButton, {
        "native-type": "reset",
        type: $props.primary ? "primary" : "tertiary",
        "aria-label": $data.labelCancel,
        onClick: withModifiers($options.cancel, ["stop", "prevent"])
      }, {
        icon: withCtx(() => [
          createVNode(_component_Close, { size: 20 })
        ]),
        _: 1
      }, 8, ["type", "aria-label", "onClick"])
    ], 32)
  ]);
}
const NcInputConfirmCancel = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-cd55dad8"]]);
export {
  NcInputConfirmCancel as N
};
